import {
  FileSpreadsheet, FileText, Presentation, FileDown, FileJson,
  Zap, Brain, TrendingUp, BarChart3, PieChart, Table, Users,
  Building2, DollarSign, Briefcase, MapPin
} from 'lucide-react';

export const FORMAT_LABELS = {
  csv: { label: 'CSV', icon: FileDown },
  excel: { label: 'Excel', icon: FileSpreadsheet },
  json: { label: 'JSON', icon: FileJson },
  pdf: { label: 'PDF', icon: FileText },
  pptx: { label: 'PowerPoint', icon: Presentation },
  docx: { label: 'Word', icon: FileSpreadsheet }
};

export const GRANULARITY_OPTIONS = [
  { id: 'summary', label: 'Summary' },
  { id: 'monthly', label: 'Monthly' },
  { id: 'weekly', label: 'Weekly' },
  { id: 'daily', label: 'Daily' }
];

export const EXPORT_OPTIONS = {
  quickReports: [
    {
      id: 'executive_summary',
      title: 'Executive Summary',
      description: 'High-level KPIs, trends, and key findings for leadership',
      icon: Zap,
      color: '#4CAF93',
      formats: ['pdf'],
      comingSoon: false,
      popular: true
    },
    {
      id: 'powerpoint',
      title: 'PowerPoint Presentation',
      description: 'Presentation-ready slides with charts and insights',
      icon: Presentation,
      color: '#FF8C42',
      formats: ['pptx'],
      comingSoon: false,
      popular: true
    }
  ],
  detailedReports: [
    {
      id: 'full_pdf',
      title: 'Full PDF Report',
      description: 'Complete analysis with all visualizations and data',
      icon: FileText,
      color: '#ef4444',
      formats: ['pdf'],
      comingSoon: false
    },
    {
      id: 'word_document',
      title: 'Word Document',
      description: 'Editable report format for customization',
      icon: FileSpreadsheet,
      color: '#2563eb',
      formats: ['docx'],
      comingSoon: false
    }
  ],
  insights: [
    {
      id: 'recommendations_report',
      title: 'Recommendations Report',
      description: 'AI-generated action items with impact estimates',
      icon: Brain,
      color: '#4CAF93',
      formats: ['pdf'],
      comingSoon: true
    },
    {
      id: 'anomaly_report',
      title: 'Anomaly Report',
      description: 'Flagged outliers and unusual patterns',
      icon: TrendingUp,
      color: '#ef4444',
      formats: ['pdf'],
      comingSoon: true
    },
    {
      id: 'trend_analysis',
      title: 'Trend Analysis',
      description: 'Historical patterns and forecasts',
      icon: BarChart3,
      color: '#8b5cf6',
      formats: ['pdf'],
      comingSoon: true
    },
    {
      id: 'department_scorecards',
      title: 'Department Scorecards',
      description: 'Per-department performance summaries',
      icon: PieChart,
      color: '#0ea5e9',
      formats: ['pdf'],
      comingSoon: true
    }
  ],
  rawData: [
    {
      id: 'timesheet_records',
      title: 'Timesheet Records',
      description: 'Individual timesheet entries with employee details',
      icon: Table,
      color: '#1e3a5f',
      formats: ['csv', 'excel', 'json']
    },
    {
      id: 'employee_summary',
      title: 'Employee Summary',
      description: 'Aggregated hours per employee with totals',
      icon: Users,
      color: '#2E5C8A',
      formats: ['csv', 'excel', 'json']
    },
    {
      id: 'department_summary',
      title: 'Department Summary',
      description: 'Hours and costs by department/cost center',
      icon: Building2,
      color: '#4CAF93',
      formats: ['csv', 'excel', 'json']
    },
    {
      id: 'paytype_breakdown',
      title: 'Pay Type Breakdown',
      description: 'Hours distribution by pay type',
      icon: DollarSign,
      color: '#FF8C42',
      formats: ['csv', 'excel', 'json']
    },
    {
      id: 'supervisor_summary',
      title: 'Supervisor Summary',
      description: 'Overtime by supervisor/manager',
      icon: Briefcase,
      color: '#6366f1',
      formats: ['csv', 'excel', 'json']
    },
    {
      id: 'location_summary',
      title: 'Location Summary',
      description: 'Hours and costs by location',
      icon: MapPin,
      color: '#0ea5e9',
      formats: ['csv', 'excel', 'json']
    }
  ]
};
